import * as React from 'react';
import { default as ReactTable, TableProps as reactTableProps, Column } from 'react-table';
import '../../Assets/styles/table.css';
import { Label, Interpolations } from '..';
import { Box, Flex } from '../../CommonUI/Layout';
import { Text } from 'ilenia';

interface TableProps extends Partial<reactTableProps> {
    id: string;
    label?: string;
    interpolations?: Interpolations;
    cols: any[];
    pl?: number;
    pr?: number;
}

export class Table extends React.Component<TableProps> {
    constructor(props: TableProps) {
          super(props);
    }

    public render() {
        const { label, id, interpolations, cols, style, pl, pr, ...rest } = this.props;
        const columns: Column[] = [];

        if (cols instanceof Array) {
            cols.map((val, idx, []) => {
                columns.push({
                    Header: <span> <Text id={val.label} /> </span>,
                    accessor: val.accessor,
                    width: val.width,
                    style: val.style,
                    Cell: val.Cell
                });
            });
        }

        return (
            <Box pl={pl || pl === 0 ?  pl : 20} pr={pr || pr === 0 ?  pr : 20}>
                <Flex>
                    { label ? <Label
                        htmlFor={id + '_label'}
                        label={label}
                        interpolations={interpolations}
                    /> : ''}
                    <ReactTable
                        style={{ maxWidth: '800px', minWidth: '490px', width: '100%', ...style }}
                        columns={columns}
                        sortable={false}
                        resizable={false}
                        filterable={false}
                        {...rest}
                    />
                </Flex>
            </Box>
        );
    }
}
